import { ChangeDetectorRef, Component, EventEmitter, HostListener, Input, Output, Renderer2, ViewChild } from "@angular/core";
import { ProductPicture } from "src/app/models/products/products";
import { ProductDetailsUiStateService } from "../product-details-ui-state.service";

@Component({
  selector: "app-plan-examples",
  templateUrl: "./plan-examples.component.html",
  styleUrls: ["./plan-examples.component.scss"],
})
export class PlanExamplesComponent {
  @Input() productPictureItems: ProductPicture[];
  
  displayRightArrow = false;
  displayLeftArrow = true;
  allowScroll = true;
  scrollPictureIndex = 0;

  constructor(private _pUiService: ProductDetailsUiStateService){

  }
  
  moveRight(): void {
    if (!this.allowScroll) return;

    const pics = document.querySelectorAll(".carousel-pic");
    if (this.scrollPictureIndex < 1 || this.scrollPictureIndex >= pics.length){
      this.displayRightArrow = false;
      return;
    }
      
    const width = pics[this.scrollPictureIndex].clientWidth;

    this.scrollPictureIndex--;
    const element = document.getElementById("product-carousel-wrapper");
    element.scrollLeft += width;
    this.displayRightArrow = true;
    this.displayLeftArrow = true;
    this.allowScroll = false;

    setTimeout(() => (this.allowScroll = true), 300);

  }

  moveLeft(): void {
    if (!this.allowScroll) return;

    const element = document.getElementById("product-carousel-wrapper");

    const pics = document.querySelectorAll(".carousel-pic");
    const lastIndex = pics.length - 1;

    if (this.scrollPictureIndex < lastIndex) {
      this.scrollPictureIndex++;
    }

    const width = pics[this.scrollPictureIndex].clientWidth;

    element.scrollLeft -= width;
    this.displayLeftArrow = !(
      element.scrollWidth + element.scrollLeft - 1 <=
      element.clientWidth
    );

    this.displayRightArrow = true;
    this.allowScroll = false;

    setTimeout(() => (this.allowScroll = true), 300);
  }

  displayCurrentPicture(path: string): void {
    this._pUiService.currentPicChange(path);
    this._pUiService.displayCurrentPicChange(true);
    document.querySelector(".anim-to-disable")?.classList.add("disable-anim");
    document
      .getElementById("viewport")
      .setAttribute(
        "content",
        "width=device-width, initial-scale=1, maximum-scale=4"
      );
  }
}
